import React from 'react';

export default {
  svg: (
    <g>
      <path
        d="M157,60.44,150,54.91l-6.95,5.53a53.74,53.74,0,0,1-63.38,2.75L68,55.46V173.87A55.72,55.72,0,0,0,93,220.4l57,37.83,57-37.83a55.72,55.72,0,0,0,25-46.53V55.46l-11.65,7.73A53.74,53.74,0,0,1,157,60.44Zm60,113.43a40.76,40.76,0,0,1-18.26,34h0L150,240.23,101.28,207.9a40.76,40.76,0,0,1-18.26-34V81.92A68.65,68.65,0,0,0,150,74a68.68,68.68,0,0,0,67,7.92Zm-63.63-55.66L150,121.56l-3.35-3.35A30.17,30.17,0,0,0,104,160.87l46,46,46-46a30.16,30.16,0,1,0-42.65-42.65Zm36.49,21.33a15.09,15.09,0,0,1-4.44,10.72L150,185.66l-35.4-35.4a15.17,15.17,0,0,1,21.45-21.45l13.95,14,14-14a15.17,15.17,0,0,1,25.88,10.72Z"
        fillRule="evenodd"
      />
    </g>
  ),
  viewBox: '0 0 300 300'
};
